import type { SettingsSearchIndex } from '@/lib/settings-search/types'
import { useEffect, useState } from 'react'
import { createLogger } from '@/lib/logger'

const logger = createLogger('hooks/useSettingsSearchIndex')
const emptyIndex: SettingsSearchIndex = { modules: {}, pages: {} }
let cachedIndex: SettingsSearchIndex | undefined
let pendingIndex: Promise<SettingsSearchIndex> | undefined

function loadIndex() {
  if (cachedIndex) return Promise.resolve(cachedIndex)
  pendingIndex ??= import('@/config/settings-search-index.generated')
    .then(module => {
      cachedIndex = module.SETTINGS_SEARCH_INDEX
      return cachedIndex
    })
    .catch(error => {
      pendingIndex = undefined
      throw error
    })
  return pendingIndex
}

/** Page names stay available immediately; setting-level terms load on demand. */
export function useSettingsSearchIndex(enabled = true): SettingsSearchIndex {
  const [index, setIndex] = useState(cachedIndex ?? emptyIndex)
  useEffect(() => {
    if (!enabled) return
    let active = true
    void loadIndex()
      .then(value => {
        if (active) setIndex(value)
      })
      .catch(() => {
        logger.warn('Settings search terms could not be loaded')
      })
    return () => {
      active = false
    }
  }, [enabled])
  return index
}
